export const stringifyDate = (day?: number, month?: number, year?: number) => {
  if (!day || !month || !year) return '';

  const paddedDay = String(day).padStart(2, '0');
  const paddedMonth = String(month).padStart(2, '0');

  return `${year}-${paddedMonth}-${paddedDay}`;
};

export const formatDateFromTimestamp = (timestamp: number | string | Date): string => {
  const date = new Date(timestamp);

  return stringifyDate(date.getUTCDate(), date.getUTCMonth() + 1, date.getUTCFullYear());
};
